module.exports = __webpack_public_path__ + "img/instagram.f32ba517.svg";